import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { getCommandsChange } from '@/api/commandes.api'
import { APP_NAME, validateCommandsPageSearchParams } from '@/lib/utils'
import CommandsChange from '@/features/commands/components/extensions/commands-change'

export const Route = createFileRoute('/_authenticated/commands-change/')({
  component: () => {
    const { t } = useTranslation()
    return (
      <CommandsChange
        queryExtension={{
          title: t('sidebar.commandes-changees'),
          querykey: 'change',
          queryFn: getCommandsChange,
        }}
      />
    )
  },

  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Commandes changées`,
      },
    ],
  }),
  validateSearch: validateCommandsPageSearchParams,
})
